

import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {TractorBeamParsedGameData} from "../server/data/TractorBeamParsedGameData";
import {TractorBeamRandomStackView} from "./TractorBeamRandomStackView";
import {Timeline} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";

export class TractorBeamRandomStacks extends BaseController {

    private _view:TractorBeamRandomStackView;

    constructor() {
        super();

        this._view = new TractorBeamRandomStackView([ // only map of top sym/reel is needed
            [0, 0], // r1
            [1, 0], // r2
            [2, 0], // r3
            [3, 0], // r4
            [4, 0], // r5
        ],
        [
            [0, 0],[0, 1],[0, 2], // r1
            [1, 0],[1, 1],[1, 2], // r2
            [2, 0],[2, 1],[2, 2], // r3
            [3, 0],[3, 1],[3, 2], // r4
            [4, 0],[4, 1],[4, 2]  // r5
        ]
        );
    }

    public playFeatureText(text:string = ""):Timeline {
        return this._view.playFeatureText(text);
    }

    public playRandomFeature(cloneAttack:boolean = false):Timeline {
        //EventHandler.dispatchEvent(new GameEvent(SpinEvent.ADD_STOP_DELAY, 1.4));
        return this._view.playBeamEmUp(cloneAttack);
    }

    public fadeOutCloneAttack():void {

    }

    public highlightReel(reelID:number):Timeline {
        return this._view.highlightReel(reelID);
    }


    public highlightSymbol(reelID:number, symID:number):Timeline {
        return this._view.highlightSymbol(reelID, symID);
    }
}
